import styled from '@emotion/styled';
import { Container } from 'atupri-component-library/lib/helpers';

export const StyledContainer = styled(Container)`
    width: 100%;
`;
